<template>
<div class="mr-2">
  <b-nav-item right no-caret>
    <button type="button" class="btn" @click="showModal()">
      <icon icon="envelope"></icon>
    </button>
  </b-nav-item>
  <b-modal ref="formmodal" :title="$t('TICKETFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
    <div class="d-block">
      <ticketform v-bind:formData="formData" v-bind:formError="formError"></ticketform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SEND')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>
<script>
import
{
  mapGetters,
  mapActions
}
from 'vuex'
import TicketApi from '@/api/admin/Ticket'
import TicketForm from './TicketForm'

export default
{
  name: 'header-dropdown-accnt',
  components:
  {
    ticketform: TicketForm
  },
  created: function()
  {
    var me = this;
  },
  data: function()
  {
    return {
      formError:
      {},
      formData:
      {
        userId: null,
        issue: '',
        answer: '',
        isSolved: false
      }
    }
  },
  methods:
  {
    showModal()
    {
      var me = this;
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        if (typeof item.ticketId != 'undefined')
        {
          item.id = item.ticketId;
          delete(item.ticketId);
        }

        var data = await TicketApi.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        userId: null,
        issue: '',
        answer: '',
        isSolved: false
      }
    }
  },
  computed:
  {

  }
}
</script>
